import { useState } from 'react'
import WrapperAccordion from '../../../general/WrapperAccordion'
import PlaySessionCheckboxes from '../../../forms/fields/PlaySessionsCheckboxes'
import OverlayWrapper from '../../../overlay/presentational/OverlayWrapper'

const PlaytimesAccordion = ({values, activeTabClass, setActiveTab, title, classes, setFieldValue, cliCinemas, clientCinemaId}) => {
    const [overlayData, openOverlay] = useState(null)
    return (
        <WrapperAccordion
            title={title}
            className={classes}
            selectionActiveClass={activeTabClass}
            collapseActiveSelection={setActiveTab}
            gapless={true}
        >
            {overlayData && <OverlayWrapper>
                <div className='performance-info'>
                    <div className='button icon button-back' onClick={()=>(openOverlay(null))}><span className='screen-reader-text'>Close button</span></div>
                    <div className='performance-info-text'><p>Standort-Programmübersicht-URL des Filmes + ?performance_id={overlayData && overlayData.performance.id}</p></div>
                </div>
            </OverlayWrapper>}
            <fieldset>
                <div className="form-content">
                    <PlaySessionCheckboxes 
                        openOverlay={openOverlay} 
                        movieData={values.movie} 
                        movieId={values.movie.id} 
                        setFieldValue={setFieldValue}
                        performancesData={values.performances} 
                        movieExtensionsItems={values.movieExtensionsItems} 
                        movieExtensionsEdited={values.movieExtensionsEdited}
                        cliMovieRelevantSourceMovies={values.cliMovieRelevantSourceMovies} 
                        cliCinemas={cliCinemas} 
                        clientCinemaId={clientCinemaId}
                    />
                </div>
            </fieldset>
        </WrapperAccordion>
    )
}

export default PlaytimesAccordion